import React from 'react'
import Card from './Card'
import SecTitle from './SecTitle'

class BankInvoiceInfo extends React.Component {


    render() {
        return (
                <div className="container box">
                    <SecTitle  type="info" title="header" />

                    <div className="auto-col-2">
                        <Card title="createbills" type="info" />
                        <Card title="1min115" type="info" />
                    </div>
                    <div className="auto-col-2">
                        <Card title="hp_reg" type="info" />
                        <Card title="nopaper" type="info" />
                    </div>
                    <div className="auto-col-2">
                        <Card title="good" type="info" />
                        <Card title="direction" type="info" />
                    </div>
                    <div className="auto-col-2">
                        <Card title="ichigenkanri" type="info" />
                        <Card title="care" type="info" />
                    </div>
                </div>
        )
    }
}

export default BankInvoiceInfo
